import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useDebitoDetalhe = (data, inscricao, tipoDebito) => {
  const [detalhes, setDetalhes] = useState([]);
  const { request: requestDetalhe, data: dataDetalhe, errors: errorsDetalhe } = useApiClient();

  useEffect(() => {
    if (tipoDebito && inscricao && data) {
      const vencimentoArray = data?.dataVencimentoDebito?.split("/");
      const rota =
        tipoDebito === "V"
          ? apiRoutes.extratofiscal.extrato.detalheDebitosVencidos
          : apiRoutes.extratofiscal.extrato.detalheDebitosAVencer;

      requestDetalhe(rota, {
        descricaoTipoOrigemDebito: data?.descricaoTipoOrigemDebito,
        ie: inscricao,
        dataVencimento: new Date(vencimentoArray[2], vencimentoArray[1] - 1, vencimentoArray[0]),
      });
    }
  }, [requestDetalhe, inscricao, tipoDebito, data]);

  useEffect(() => {
    if (dataDetalhe) {
      setDetalhes(dataDetalhe.result);
    }
    if (errorsDetalhe) {
      toast.error(errorsDetalhe.message);
    }
  }, [dataDetalhe, detalhes, errorsDetalhe]);

  return detalhes;
};

export default useDebitoDetalhe;
